import { isValid, parseISO } from "date-fns";

export const parseJsonAttribute = (key: string, value: any) => {
	const parsedValue = parseISO(value);
	const parsedValueIsValid = isValid(parsedValue) && isNaN(value);

	if (!parsedValueIsValid) return value;
	return parsedValue;
};
